import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { IListContract } from 'src/app/models/verification';

@Component({
  selector: 'app-estornar-contract-card',
  templateUrl: './estornar-contract-card.component.html',
  styleUrls: ['./estornar-contract-card.component.scss']
})
export class EstornarContractCardComponent implements OnChanges {
  @Input() contract!: IListContract;

  contractForm!: FormGroup;

  bodyExpanded = false;

  modeUrl = 'visualizar';

  constructor(private _apiContractService: ApiContractService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.buildForm();

    if (this.contractForm) {
      this.contractForm.patchValue(this.contract);
    }
  }

  buildForm(): void {
    this.contractForm = new FormGroup({
      Checked: new FormControl(false),
      Disabled: new FormControl(false),
      Chanel: new FormControl(null),
      CompanyId: new FormControl(null),
      ContractDate: new FormControl(null),
      RegistertDate: new FormControl(null),
      ContractId: new FormControl(null),
      ContractStatus: new FormControl(null),
      ContractType: new FormControl(null),
      Error: new FormControl(null),
      FinancialInstitution: new FormControl(null),
      Incomplete: new FormControl(null),
      Number: new FormControl(null),
      Status: new FormControl(null)
    });
  }

  get checkedControl() {
    return this.contractForm.get('Checked') as FormControl;
  }

  checkUncheckContract(contract: IListContract) {
    this._apiContractService.setContractsArray(contract);
  }

  formatStatusText(text: string): string {
    const splittedText = text.split(' ');
    return splittedText[splittedText.length - 1];
  }
}
